import { DEFAULT_LATEST } from 'constants/dateLimits';
import { ValidateJSModel } from 'forms/shared/types/validatejs';
import currencyModelValidator from 'forms/shared/validators/models/currency';
import { setToStartOfMonth } from 'helpers/date';
import { FinancialGamblingItemModel } from '../types';

export const financialGamblingItemValidator: ValidateJSModel<FinancialGamblingItemModel> = {
  Dates: (value, attributes, attributeName, options) => ({
    presence: true,
    daterange: { earliest: setToStartOfMonth(options?.applicantBirthdate), latest: DEFAULT_LATEST },
  }),

  Losses: {
    model: {
      validator: currencyModelValidator,
    },
  },

  Description: { hasValue: true },

  Actions: { hasValue: true },
};
